module.exports = __webpack_public_path__ + "media/images/front/about/thumbnail2-d0fa9e8544dd19d44e90e1ab1edb9a90.jpg";